module.exports =
  'ACCOUNT':
    'NO_NAME': '名前未設定'




// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/components/account/i18n/ja.coffee